import { Record, List } from 'immutable'

const Member = Record({
  id:null,
  name:null,
  customer:null,
  picture:null,
});
export default Member;



// WEBPACK FOOTER //
// ./src/vo/Member.js